import React, { useEffect, useRef, useState } from 'react';
import { PrintOutlined } from '@mui/icons-material';
import { Box, Button, Container, Typography, TextField,Card } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import GradientLoader from '../../components/CommanComponents/GradientLoader';
import physicalcard from '../../assets/physicalcard.png';
import { QRCodeCanvas } from 'qrcode.react';
import logo from '../../assets/cashilogo.png'

const PrintPhysicalCard = () => {

    const qrRef    = useRef();
    const navigate = useNavigate();

    const user = JSON.parse(sessionStorage.getItem('user') || '{}');

    const [loading,   setLoading]   = useState(false);
    const [datar,     setDatar]     = useState([]);
    const [cardCount, setCardCount] = useState(25);   

    const store_id = user?.store_info?.store_id || 'STORE';

    //PRINT CONFIG
    const handlePrint = useReactToPrint({
        contentRef: qrRef,
        documentTitle: "QR Cards A3",
        pageStyle: `
          @page { size: A3 landscape; margin: 5mm; }
          body {
            -webkit-print-color-adjust: exact !important;
            color-adjust: exact !important;
            background: white !important;
          }
          .MuiCard-root { page-break-inside: avoid; }
        `,
      });

    const generateId = (length = 6) => 
    {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";

      for (let i = 0; i < length; i++) { result += chars.charAt(Math.floor(Math.random() * chars.length)); }

      const now    = new Date();
      const day    = String(now.getDate()).padStart(2, "0");
      const hour   = String(now.getHours()).padStart(2, "0");
      const minute = String(now.getMinutes()).padStart(2, "0");

      return `${result}${day}${hour}${minute}`;

    };

    useEffect(() => 
    {
      let isMounted = true;

      const generate = () => 
      {
          setLoading(true);

          if (cardCount <= 0) 
          {
            if (isMounted) setDatar([]);
            setLoading(false);
            return;
          }

          const list = [];
          

          for (let i = 1; i <= cardCount; i++) 
          {
            const baseTime = generateId(6);
            list.push({ id: `${store_id}-${baseTime}-${i}` });
          }

          if (isMounted) setDatar(list);
          setLoading(false);
      };

      generate();

      return () => { isMounted = false; };

    }, [cardCount, store_id]);

    //CLEAR FILTER
    const clearFun = () => { setCardCount(1); };


  return (
    <Box>
      <Container>

          {/* BACK BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
            <Button variant="contained" sx={{ backgroundColor: '#000000', color: '#ffffff' }} onClick={() => navigate(-1)}> Back </Button>
          </Box>

          {/* TITLE */}
          <Typography variant="h6"  gutterBottom sx={{ background: 'linear-gradient(195deg, #49a3f1, #1A73E8)', p: 1, color: '#ffffff',
              borderRadius: '4px', mb: 3, display: 'flex', alignItems: 'center',}}> <PrintOutlined sx={{ mx: 1 }} /> Print Physical Card
          </Typography>
          
          {/* PRINT BUTTON */}
          <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
              onClick={handlePrint} > <PrintOutlined sx={{ mx: 1 }} /> Print </Button >  

            <Button variant="contained" sx={{ background: 'linear-gradient(195deg, #42424a, #191919)', color: '#ffffff', ml:1}}
              onClick={() => navigate('../printphysicalback')} > <PrintOutlined sx={{ mx: 1 }} /> Back Print </Button >      
          </Box>
       
          {/* FILTER */}
          <Box sx={{ display: 'flex',flexWrap:'wrap', gap: 2, mb: 2 }}>        
            <TextField  label="Card Count" value={cardCount} onChange={(e) => setCardCount(Number(e.target.value) || 0)} sx={{ minWidth: 160 }} /> 
            
            <Button variant="outlined" color="error" sx={{ height: 56 }} onClick={() => {clearFun()}}> Clear Filter </Button>
          
          </Box>
          
          <Box ref={qrRef} className="print-grid" sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)",
              gridTemplateRows: "repeat(5, auto)", gap: "0mm", p: "0mm",boxSizing: "border-box",}} >

              {datar.length > 0 ? (
                datar.map((item, idx) => (
                  <Card sx={{ width: "88mm", height: "59mm", borderRadius: "0mm", position: "relative", backgroundImage: `url(${physicalcard})`,
                        backgroundSize: "100% 100%", backgroundRepeat: "no-repeat", backgroundPosition: "center", boxShadow: "none", paddingLeft:"15px",
                        marginBottom: "1mm", marginTop: "1mm", pageBreakInside: "avoid", breakInside: "avoid", }} >
                    
                        {/* LOGO */}
                        <Box sx={{ display: "none", justifyContent: "space-between" }}>
                          <img src={user?.store_info?.store_image || logo} alt="Logo" style={{ height: 30, marginTop: 100 }} />
                        </Box>

                        {/* QR CODE */}
                        <Box sx={{ position: "absolute", right: "-5px", bottom: "32px",width: "85px",height: "85px",}}>
                            <QRCodeCanvas value={item.id} size={85} style={{ width: "60%", height: "60%", padding: 2 }} />
                        </Box>

                  </Card>
                ))
              ) : ( <Typography sx={{ p: 3, color: "#888" }}> No QR data available. </Typography> )}
          </Box>
          
    
      </Container>

       {loading && <GradientLoader text="Loading" />}        {/* // loader */}
    </Box>
  );

}

export default PrintPhysicalCard;